import { Button, Image, legacyColors, StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.black};
  border-color: ${({ theme }) => theme.colors.secondary.lighter};
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledRoomImage = styled(Image)`
  width: 3.6rem;
  height: 3.6rem;
  position: relative;
  top: 0.2rem;
`;

export const StyledRoomHeaderWrapper = styled.div<{ $isTabletAndNotSplitScreen: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.6rem ${({ $isTabletAndNotSplitScreen }) => ($isTabletAndNotSplitScreen ? '4.6rem' : '2.4rem')};
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondary.light};
  position: relative;
  z-index: 4;
`;

export const StyledRoomDescriptionWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const StyledRoomActionsWrapper = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const StyledSideSectionCloseBtn = styled.button`
  margin-left: 0.8rem;
  align-self: flex-start;
  position: relative;
  top: 0.4rem;
  svg {
    height: 2.8rem;
    width: 2.8rem;
    path {
      fill: ${({ theme }) => theme.colors.grey[200]};
    }
  }
`;

export const StyledLoading = styled.div<{ width: string }>`
  ${StyledLoadingPlaceholder}
  z-index: 2;
  width: ${({ width }) => width};
  height: 3.8rem;
  background: linear-gradient(
    to right,
    ${legacyColors.misc.darkLoadingPrimary},
    ${legacyColors.misc.darkLoadingSecondary},
    ${legacyColors.misc.darkLoadingPrimary}
  );
`;

export const StyledRoomTitle = styled.h5`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: 1.8rem;
  font-weight: 500;
  margin-bottom: 0;
`;
